import * as types from '@/store/types'

const state = {
  // True if the splash screen should be shown, false otherwise
  isActive: true
}

const actions = {
  disableSplashScreen ({commit}) {
    commit(types.SPLASH_SCREEN__DISABLE)
  }
}

const mutations = {
  [types.SPLASH_SCREEN__DISABLE] (state) {
    state.isActive = false
  }
}

export default {
  state,
  actions,
  mutations
}
